export default {"src":"/_next/static/media/plusCircle.71ba372a.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};